import {ThemeType, UserConfig} from "./UserConfig";
import {CurrentUser} from "../services/user/models/CurrentUser";
import accountOpeningDomain from "app/configs/AccountOpeningDomainConfig";

export const OPT_INTERNATIONAL = "INTERNATIONAL";

export enum Branding {
    TF = "TF",
    TC = "TC",
    GAME = "GAME",
    TRADEON = "TRADEON",
    IV = "IV",
    IINVEST = "IINVEST",
    OPEN_TRADER = "OPEN_TRADER",
    OPEN_MARKETS = "OPEN_MARKETS",
    IG = "IG",
    BELLMONT = "BELLMONT",
    FUTURE_ASSIST = "FUTURE_ASSIST",
    ALLFIN = "ALLFIN",
    WAIMAK = "WAIMAK",
    SUUBEE = "SUUBEE",
    LIQUIDITY = "LIQUIDITY"
}

export function defaultTheme(branding: Branding): ThemeType {
    switch (branding) {
        case Branding.OPEN_TRADER:
        case Branding.OPEN_MARKETS:
        case Branding.WAIMAK:
        case Branding.LIQUIDITY:
            return "light";
        case Branding.BELLMONT:
        case Branding.FUTURE_ASSIST:
        case Branding.ALLFIN:
        case Branding.SUUBEE:
            return "dark";
        default:
            return "light";
    }
}

export function themingEnabled(branding: Branding): boolean {
    switch (branding) {
        case Branding.OPEN_TRADER:
        case Branding.OPEN_MARKETS:
        case Branding.BELLMONT:
        case Branding.FUTURE_ASSIST:
        case Branding.IV:
        case Branding.ALLFIN:
        case Branding.WAIMAK:
        case Branding.SUUBEE:
        case Branding.LIQUIDITY:
            return true;
        default:
            return false;
    }
}

/*
 * Since we have lots of Brandings that are all the "OpenMarkets"/"OpenTrader" application,
 * this is a convenience function for doing that check
 */
export function isOpenMarketsAppBranding(branding: Branding): boolean {
    switch (branding) {
        case Branding.OPEN_TRADER:
        case Branding.OPEN_MARKETS:
        case Branding.BELLMONT:
        case Branding.FUTURE_ASSIST:
        case Branding.ALLFIN:
        case Branding.WAIMAK:
        case Branding.SUUBEE:
        case Branding.LIQUIDITY:
            return true;
        default:
            return false;
    }
}

export function showAccountOpeningDialog(branding: Branding): boolean {
    switch (branding) {
        case Branding.ALLFIN:
            return false;
        default:
            return true;
    }
}

export const ALLFIN_JOIN_LINK = "https://allfin.com/aocai-account-application";
export const INTERNATIONAL_INVESTOR_LINK = "https://opentrader.com.au/legal/forms";

export function getAccountOpeningPath(
    branding: Branding,
    currentUser: CurrentUser | UserConfig,
    type: string = ""
    ): string {
    const isInternationalInvestor = type === OPT_INTERNATIONAL;
    let accountOpeningUrl = "";

    // Check if it's international investor
    if (isInternationalInvestor) {
        accountOpeningUrl = INTERNATIONAL_INVESTOR_LINK;
    } else {
        accountOpeningUrl = accountOpeningDomain;
    }

    // Some brands have specific links for account opening
    switch (branding) {
        case Branding.ALLFIN:
            return `${ALLFIN_JOIN_LINK}?accountId=${currentUser.id}`;
        default:
            return accountOpeningUrl;
    }
}